import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { TopBar } from "@/components/TopBar";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { ScrollToTop } from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Cookies from "@/pages/legal/Cookies";
import Returns from "@/pages/legal/Returns";
import Admin from "@/pages/admin/Admin";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <>
        <ScrollToTop />
        <Routes>
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </>
    );
  }

  return (
    <CartProvider>
      <ScrollToTop />
      <TopBar />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produse" element={<Products />} />
          <Route path="/produs/:slug" element={<ProductDetail />} />
          <Route path="/pachete" element={<Products />} />
          <Route path="/despre" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/comanda-plasata" element={<OrderSuccess />} />
          <Route path="/termeni-si-conditii" element={<Terms />} />
          <Route path="/politica-de-confidentialitate" element={<Privacy />} />
          <Route path="/politica-de-cookies" element={<Cookies />} />
          <Route path="/politica-de-retur" element={<Returns />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
      <Toaster position="top-center" richColors />
    </CartProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
